














import { Vue, Component, Prop } from "vue-property-decorator";
import { IAccount } from "@/models/accounts";
import { IAffiliate } from "@/models/affiliate";

@Component({
  components: {
    "account-settings-form": () =>
      import("@/components/app/global/affiliate/accountSettingsForm.vue"),
    "payout-destinations-provider": () =>
      import("@/components/app/global/affiliate/payoutDestinationsProvider.vue")
  }
})
export default class AdminClientAffiliateSettingsView extends Vue {
  // Props
  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: true })
  public affiliate!: IAffiliate;

  public get brandId() {
    return this.affiliate.account?.brand_id;
  }
}
